function filterPages(pathPrefix, pages) {
    return pages.filter(({ to }) => to.includes(pathPrefix) && to.indexOf(pathPrefix) === 0);
}
function reduceAltHighlights(pages) {
    return pages.reduce((previous, current) => {
        if (!current.altHighlight)
            return previous;
        else if (Array.isArray(current.altHighlight))
            return [...previous, ...current.altHighlight];
        else
            return [...previous, current.altHighlight];
    }, []);
}
export function findAltHighlights(pages, pathPrefix) {
    return reduceAltHighlights(filterPages(pathPrefix, pages));
}
